import { injectable, inject, named } from 'inversify';

import type { GetMediaParams } from '../../../../types/media';
import type { Config } from '../../../../types/config';
import AccountService from '../AccountService';
import type { GetTokenResponse } from '../../../../types/entitlement';
import GenericEntitlementService from '../../entitlement/GenericEntitlementService';
import env from '../../../env';

import type AWSCognitoAccountService from './AWSCognitoAccountService';

@injectable()
export default class AWSCognitoEntitlementService extends GenericEntitlementService {
  constructor(@inject(AccountService) @named('COGNITO_STRIPE') private readonly accountService: AWSCognitoAccountService) {
    super();
  }

  protected getToken = async <T>(url: string, body: unknown = {}): Promise<T> => {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      credentials: 'include',
    });

    return (await response.json()) as T;
  };

  getMediaToken = async (config: Config, id: string, jwt?: string, params?: GetMediaParams, accessType?: string) => {
    const viewerToken = this.accountService.getViewerToken();
    const provider = viewerToken ? viewerToken.provider : 'cognito';
    const drmPolicyId = (config.contentProtection?.drm?.defaultPolicyId || config.custom?.drmPolicyId) as string | undefined;

    const data = await this.getToken<GetTokenResponse>(`${env.APP_ACCOUNT_API_BASE_URL}/entitlement`, {
      provider,
      credentials: {
        token: jwt || '',
      },
      asset: {
        id,
        drmPolicyId,
        params,
        accessType,
      },
    });

    if (!data.entitled) throw new Error('Unauthorized');

    return data.token;
  };
}
